import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, BaseStyles } from '@primer/react';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider colorMode="night">
        <BaseStyles>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </BaseStyles>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
